import { render, staticRenderFns } from "./skill-question.vue?vue&type=template&id=64c0fd30"
import script from "./skill-question.vue?vue&type=script&lang=js"
export * from "./skill-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports